<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> لیست تخفیفات حجمی </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderCreateVolumeDiscountDialog">
        ایجاد تخفیف جدید
      </BButton>
    </template>
    <CustomTable
      v-if="volumeDiscoutnsList"
      :pageNumber="volumeDiscountsFilters.pageNumber"
      :count="volumeDiscountsFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="volumeDiscoutnsList"
      @changePage="changePage"
    >
      <template #discountValue="data">
        {{
          data.item.discountType == 1
            ? Intl.NumberFormat("en-US").format(data.item.discountValue)
            : data.item.discountValue
        }}
        {{ discountTypes[data.item.discountType] }}
      </template>
      <template #minOrderQuantity="data">
        {{ data.item.minOrderQuantity }}
        {{ volumeDiscountPersianTypes[data.item.volumeDiscountType] }}
      </template>
      <template #minTotalPrice="data">
        <template v-if="data.item.minTotalPrice">
          {{ Intl.NumberFormat("en-US").format(data.item.minTotalPrice) }} تومان
        </template>
        <template v-else> - </template>
      </template>
      <template #actions="data">
        <BButton
          variant="transparent"
          size="sm"
          @click="renderUpdateVolumeDiscountDialog(data.item)"
        >
          <FeatherIcon icon="EditIcon" size="23" class="text-info" />
        </BButton>
        <BButton
          variant="transparent"
          size="sm"
          @click="renderDeleteVolumeDiscounConfirmationDialog(data.item)"
        >
          <FeatherIcon icon="Trash2Icon" size="23" class="text-danger" />
        </BButton>
      </template>
    </CustomTable>
    <CreateVolumeDiscountDialog
      @refetch="getAllVolumeDiscounts"
    ></CreateVolumeDiscountDialog>
    <UpdateVolumeDiscountDialog
      :defaultVolumeDiscount="tempSelectedItem"
      @refetch="getAllVolumeDiscounts"
    >
    </UpdateVolumeDiscountDialog>
    <DeleteVolumeDiscountConfirmationDialog
      :selectedVolumeDiscount="tempSelectedItem"
      @refetch="getAllVolumeDiscounts"
    ></DeleteVolumeDiscountConfirmationDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllVolumeDiscounts();
  },
  data() {
    return {
      isLoading: false,
      volumeDiscoutnsList: null,
      totalCount: null,
      tempSelectedItem: null,
      volumeDiscountsFilters: {
        pageNumber: 1,
        count: 10,
      },
      tableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "volumeDiscountType",
          label: "مورد تخفیف",
          formatter: (value) => this.volumeDiscountPersianTypes[value],
        },
        {
          key: "discountValue",
          label: "مقدار تخفیف",
        },
        {
          key: "minOrderQuantity",
          label: "حداقل تعداد آیتم در سفارش",
        },
        {
          key: "minTotalPrice",
          label: "حداقل مبلغ سفارش",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      discountTypes: {
        1: "تومان",
        2: "%",
      },

      volumeDiscountPersianTypes: {
        1: "درس",
        2: "دوره",
      },
    };
  },
  methods: {
    renderCreateVolumeDiscountDialog() {
      this.$bvModal.show("create-volume-discount-dialog");
    },
    renderUpdateVolumeDiscountDialog(selectedItem) {
      this.tempSelectedItem = JSON.parse(JSON.stringify(selectedItem));
      this.$bvModal.show("update-volume-discount-dialog");
    },
    renderDeleteVolumeDiscounConfirmationDialog(selectedItem) {
      this.tempSelectedItem = selectedItem;
      this.$bvModal.show("delete-volume-discount-confirmation-dialog");
    },
    changePage(pageNumber) {
      this.volumeDiscountsFilters.pageNumber = pageNumber;
      this.getAllVolumeDiscounts();
    },
    async getAllVolumeDiscounts() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllVolumeDiscounts = new GetAllVolumeDiscounts(_this);
        getAllVolumeDiscounts.setRequestParam(_this.volumeDiscountsFilters);
        await getAllVolumeDiscounts.fetch((res) => {
          _this.volumeDiscoutnsList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    CreateVolumeDiscountDialog,
    UpdateVolumeDiscountDialog,
    DeleteVolumeDiscountConfirmationDialog,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import CreateVolumeDiscountDialog from "@/views/components/VolumeDiscounts/CreateVolumeDiscountDialog.vue";
import UpdateVolumeDiscountDialog from "@/views/components/VolumeDiscounts/UpdateVolumeDiscountDialog.vue";
import DeleteVolumeDiscountConfirmationDialog from "@/views/components/VolumeDiscounts/DeleteVolumeDiscountConfirmationDialog.vue";
import { BButton } from "bootstrap-vue";
import { GetAllVolumeDiscounts } from "@/libs/Api/VolumeDiscounts";
</script>
